/* eslint-disable @reatom/unit-naming-rule */
import { action, reaction } from '@reatom/framework'

import { Result } from '@blade/std-lib'
import { delugeIdAtom } from '@root/entities/auth'
import { selectedNetworkAtom } from '@root/entities/network'
import { favoriteMetasModelByNetwork } from '@root/entities/pair/atoms/reatom-favorite-metas'

import { fetchFavoriteMetasRequestAction } from './favorite-requests'

export * from './reatom-favorite-pairs'
export * from './reatom-toggle-favorite-pair'
export * from './reatom-set-favorites-order'
export * from './favorite-requests'

const loadFavoriteMetasReaction = reaction(async (ctx) => {
  const delugeId = ctx.spy(delugeIdAtom)
  if (!delugeId) {
    return
  }
  const network = ctx.spy(selectedNetworkAtom)
  const result = await ctx.schedule(() =>
    fetchFavoriteMetasRequestAction(ctx, { network }),
  )
  if (Result.isSuccess(result)) {
    favoriteMetasModelByNetwork[network].updateFromDtos(ctx, result.success)
  }
})

export const initializeFavoritePairsAction = action(async (ctx) => {
  loadFavoriteMetasReaction(ctx)
}, 'initializeFavoritePairsAction')
